'use client'

import PropTypes from 'prop-types'
import MUITypography from '@mui/material/Typography'

export const SmallTitle = ({ title, sx }) => {
  if (!title) return null
  return (
    <MUITypography
      data-testid="SmallTitle"
      variant="subtitle1"
      sx={{ padding: '0px 12px', textTransform: 'uppercase', fontWeight: 500, mb: 0, ...sx }}
      noWrap
    >
      {title}
    </MUITypography>
  )
}

SmallTitle.propTypes = {
  title: PropTypes.string,
  sx: PropTypes.object
}
